// extracted by mini-css-extract-plugin
export var contentCTA = "gated-downloadable-layout-module--contentCTA--48642";
export var contentDescription = "gated-downloadable-layout-module--contentDescription--62b99";
export var contentTitle = "gated-downloadable-layout-module--contentTitle--d10a8";
export var contentType = "gated-downloadable-layout-module--contentType--11cdb";
export var formContainer = "gated-downloadable-layout-module--formContainer--3dbad";
export var heroContentContainer = "gated-downloadable-layout-module--heroContentContainer--68854";
export var heroLayoutContainer = "gated-downloadable-layout-module--heroLayoutContainer--24d3d";
export var moduleContainer = "gated-downloadable-layout-module--moduleContainer--d84d5";